import InterstitialScreen from "./InterstitialScreen";
import NextStepButton from "../shared/NextStepButton";
import MergeLogo from "../shared/MergeLogo";
import { Connector } from "../../config/types";
import check from "../../assets/check-success.svg";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";

type Props = {
  connector?: Connector;
  onClickBottomAction: () => void;
  customButtonText?: string;
};

const SuccessScreen = ({ connector, onClickBottomAction, customButtonText }: Props) => {
  const { shouldHideMergeLogo } = useAgentHandlerLinkModalContext();

  return (
    <InterstitialScreen
      connector={connector}
      centralIcon={<img src={check} />}
      text={"Success!"}
      subText={`You've connected your account`}
      bottomAction={
        <NextStepButton onClick={onClickBottomAction}>
          {customButtonText ?? "Finish setup"}
        </NextStepButton>
      }
      footerProps={{
        showFooter: !shouldHideMergeLogo,
        footerChildren: (
          <>
            <div className="flex items-center justify-center h-full">
              <p className=" text-white mr-1.5 text-sm">{"Powered by"}</p>
              <MergeLogo />
            </div>
          </>
        ),
        onFooterClick: (e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();
          window.open("https://www.merge.dev", "_blank")?.focus();
        },
      }}
      isSuccessScreen
    />
  );
};

export default SuccessScreen;
